import { ArrowBack as IconArrowBack } from "@mui/icons-material";
import { Box, IconButton, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import { MapPanelHeader } from "~/modules/map/components/MapPanel";

type TeamReportsHeaderProps = {
    backHref: string;
};

export function TeamReportsHeader({ backHref }: TeamReportsHeaderProps) {
    const { t } = useTranslation("project");

    return (
        <MapPanelHeader>
            <IconButton component={Link} color="inherit" to={backHref}>
                <IconArrowBack />
            </IconButton>
            <Box paddingBlock={1} flexGrow={1}>
                <Typography variant="h6">{t("projectReviewVisitV2.teamReportsRoute.title")}</Typography>
            </Box>
        </MapPanelHeader>
    );
}
